/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import { useCallback } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { RadioButton } from '../../../components/common';
import { makeSelectTranslationWizardChangeLock } from '../../../modules/internationalization/intSelectors';
import { IWizardChangeLockTranslation } from '../../../modules/internationalization/types/wizards/changeLock';
import { IRootReducer } from '../../../reducers/rootReducer';
import { TWizardChangeLockSetParamsPayload } from '../types/wizardChangeLockActionTypes';
import { wizardChangeLockSetParamsAction } from '../wizardChangeLockActions';
import { EWizardChangeLockSteps } from '../wizardChangeLockConstant';
import { IWizardChangeLockReducer } from '../wizardChangeLockReducer';
import { makeSelectWizardChangeLockIsUnlockSubscribers } from '../wizardChangeLockSelectors';
import { WizardChangeLockStyled } from './styled/WizardChangeLockStyled';

const WizardChangeLockOperationSelection = (props: IConnectedProps & IDispatchProps) => {

    const {
        isUnlockSubscribers,
        translation,

        saveCurrentStepState,
    } = props;

    const stepTranslation = translation[EWizardChangeLockSteps.StepOperationSelection];

    const changeRadioHandler = useCallback(() => {
        saveCurrentStepState({
            isUnlockSubscribers: !isUnlockSubscribers,
        });
    }, [isUnlockSubscribers, saveCurrentStepState]);

    return <WizardChangeLockStyled>
        <div className="wizard-change-lock__title">
            {stepTranslation.selectionInfo}
        </div>
        <RadioButton checked={!isUnlockSubscribers}
                     className="wizard-change-lock__radio-button"
                     label={stepTranslation.lockSubscribers}
                     onChange={(isUnlockSubscribers) ? () => changeRadioHandler() : () => {}}
        />
        <RadioButton
            checked={isUnlockSubscribers}
            className="wizard-change-lock__radio-button"
            label={stepTranslation.unlockSubscribers}
            onChange={(!isUnlockSubscribers) ? () => changeRadioHandler() : () => {}}
        />
    </WizardChangeLockStyled>
};

export interface IConnectedProps extends Pick<IWizardChangeLockReducer, 'isUnlockSubscribers' > {
    translation: IWizardChangeLockTranslation;
}

interface IDispatchProps {
    saveCurrentStepState: (payload: TWizardChangeLockSetParamsPayload) => void;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    isUnlockSubscribers: makeSelectWizardChangeLockIsUnlockSubscribers(),
    translation: makeSelectTranslationWizardChangeLock(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    saveCurrentStepState: (payload: TWizardChangeLockSetParamsPayload) =>
        dispatch(wizardChangeLockSetParamsAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardChangeLockOperationSelection);
